/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTournamentsIdCloseRegistrationMutationResponse,
  PostTournamentsIdCloseRegistrationPathParams,
} from "../types/PostTournamentsIdCloseRegistration.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTournamentsIdCloseRegistrationMutationKey = () =>
  [{ url: "/tournaments/:id/close-registration" }] as const;

export type PostTournamentsIdCloseRegistrationMutationKey = ReturnType<
  typeof postTournamentsIdCloseRegistrationMutationKey
>;

/**
 * @summary Закрыть регистрацию (изменить статус с RegistrationOpen на RegistrationClosed)
 * {@link /tournaments/:id/close-registration}
 */
export async function postTournamentsIdCloseRegistration(
  id: PostTournamentsIdCloseRegistrationPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTournamentsIdCloseRegistrationMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/tournaments/${id}/close-registration`,
    ...requestConfig,
  });
  return res;
}

export function postTournamentsIdCloseRegistrationMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postTournamentsIdCloseRegistrationMutationKey();
  return mutationOptions<
    ResponseConfig<PostTournamentsIdCloseRegistrationMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCloseRegistrationPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return postTournamentsIdCloseRegistration(id, config);
    },
  });
}

/**
 * @summary Закрыть регистрацию (изменить статус с RegistrationOpen на RegistrationClosed)
 * {@link /tournaments/:id/close-registration}
 */
export function usePostTournamentsIdCloseRegistration<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTournamentsIdCloseRegistrationMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: PostTournamentsIdCloseRegistrationPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postTournamentsIdCloseRegistrationMutationKey();

  const baseOptions = postTournamentsIdCloseRegistrationMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTournamentsIdCloseRegistrationMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCloseRegistrationPathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTournamentsIdCloseRegistrationMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCloseRegistrationPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTournamentsIdCloseRegistrationMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: PostTournamentsIdCloseRegistrationPathParams["id"] },
    TContext
  >;
}
